import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-link',
  templateUrl: './product-link.component.html',
  styleUrls: ['./product-link.component.css']
})
export class ProductLinkComponent implements OnInit {
    productLinkKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.productLinkKeyno = this.stateService.getStateParams()['productlink_keyno'];
    }

    private async loadEdit() {
        if (!!this.productLinkKeyno) {
            this.edit = (await this.datatask.Post(1853, { productlink_keyno: this.productLinkKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1854, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    argtype: string;
    argvalue: string;
    productlinktype_keyno: string;
    page_heading: string;
    prod_id: string;
    prod_keyno: string;
    productlink_keyno: string;
    prod_name: string;
    quantity: string;
    note: string;
    reg_by_info: string;
    mod_by_info: string;
}
